<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <span class="text-blue-400 items-center justify-center fas fa-route">
                </span>
            </div>
        </template>
        <div>
            <ui-select-searchable label="Estimate" :options="estimates" v-model="estimateId"
                                  placeholder="Please select which estimate to import"
                                  class="xl:col-span-12"
            ></ui-select-searchable>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="busy" @click="send"
                               :disabled="!estimateId"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {toCurrency} from "../../../utils";
import UiSelectSearchable from "../../ui/UiSelectSearchable.vue";
import {Estimate} from "@models";

export default {
    components: {UiSelectSearchable, UiButtonNew, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Import Sections/Tasks/Items from Estimate'
        },
        button: {
            type: String,
            default: 'Import from Estimate'
        },
        packageReference: null,
    },
    data() {
        return {
            to: '',
            busy: false,
            error: false,
            estimates: [],
            estimateId: null,
        }
    },
    methods: {
        async send() {
            if (this.estimateId) {
                this.busy = true;
                await this.handle(await Estimate.find(this.estimateId.value), this)
                this.busy = false;
            }
        },
    },
    async mounted() {
        this.estimates = (await Estimate.list(this.packageReference)).map((e) => {
            return {
                label: '#' + e.reference + ' ' + e.title + ' - ' + toCurrency(e.total),
                value: e.id
            }
        })
    }
}
</script>
